import { cn } from '@/lib/utils/utils'

interface CountryFlagIconProps {
    src?: string | null
    emoji?: string
    className?: string
}

export function CountryFlagIcon({ src, emoji, className }: CountryFlagIconProps) {
    if (src) {
        return (
            <img
                src={src}
                alt=''
                aria-hidden
                className={cn(
                    'h-4 w-6 shrink-0 rounded-[2px] object-cover ring-1 ring-slate-200/60 shadow-[0_1px_2px_rgba(0,0,0,0.05)]',
                    className
                )}
            />
        )
    }

    if (emoji) {
        return (
            <span className={cn('inline-flex shrink-0 text-sm leading-none', className)} aria-hidden>
                {emoji}
            </span>
        )
    }

    return null
}
